import { i18n } from "../../i18n";
import { GpxImportError, GpxImportErrorCode } from "./gpxImportError";

// The error codes are camelCase because they are a TypeScript enum; the locale
// files are snake_case because they are Rails'. `gpxImport.errors.notGpx` was
// asked for and `gpx_import.errors.not_gpx` was on file, so every import error
// showed the reader the key instead of the message.
export const gpxImportErrorKey = (code: string): string =>
  `gpx_import.errors.${code.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)}`;

/**
 * Resolve any error thrown by an import flow into a localized, user-facing message
 * that states the specific reason. Unknown errors fall back to a safe generic string.
 */
export function gpxImportErrorMessage(error: unknown): string {
  const t = i18n.global.t;

  if (error instanceof GpxImportError) {
    return t(gpxImportErrorKey(error.code));
  }

  // MultiRouteError from ImportFileHelper predates this taxonomy; map it here so the
  // message stays consistent without changing that class's public shape.
  if (error instanceof Error && error.name === "MultiRouteError") {
    return t(gpxImportErrorKey(GpxImportErrorCode.MultipleRoutes));
  }

  return t(gpxImportErrorKey(GpxImportErrorCode.Generic));
}
